import React, { Component } from "react";
import { Wrapper, Card } from "app/NativeComponents/common";

import { ToggleSwitch } from "app/NativeComponents/snippets";

import { renderDate, renderPrice, numberWithCommas } from "app/NativeActions";

import moment from "moment";

class FrequencySwitch extends Component {
  constructor(props) {
    super(props);

    this.handleModalPress = this.handleModalPress.bind(this);
    this.handleShowModule = this.handleShowModule.bind(this);
  }

  handleModalPress() {
    const { plan_frequency } = this.props.billing_details.plan_module_info;
    const { slug } = this.props.billing_details;
    this.props.updatePlan({
      token: this.props.token,
      plan: null,
      frequency: plan_frequency == "annually" ? "monthly" : "annually",
      slug: slug,
      type: "update_plan_frequency"
    });
  }

  handleShowModule(value) {
    const { plan_frequency } = this.props.billing_details.plan_module_info;

    this.props.setModal({
      title: plan_frequency == "annually" ? "Pay Monthly?" : "Pay Annually?",
      description:
        plan_frequency == "annually"
          ? "Do you want to switch to monthly payments? This will not take effect until your next billing cycle."
          : "Do you want to switch to annual payments? This will not take effect until your next billing cycle.",
      submit:
        plan_frequency == "annually"
          ? "Switch To Monthly? Payments"
          : "Switch To Annual Payments",
      onPress: this.handleModalPress,
      cancel: "Not right now."
    });
    this.props.toggleModal({ show: true, type: "normal" });
  }
  render() {
    const {
      billing_details: { plan_module_info }
    } = this.props;

    if (plan_module_info) {
      const {
        approved_to_charge,
        canceled,
        enterprise,
        paused,
        tier,
        plan_frequency
      } = plan_module_info;

      if (
        approved_to_charge == 1 &&
        canceled != 1 &&
        tier < 3 &&
        enterprise != 1 &&
        paused != 1 &&
        plan_module_info.slug !== "messages"
      ) {
        return (
          <Card>
            <ToggleSwitch
              value={plan_frequency === "annually"}
              onChange={this.handleShowModule}
              title={"Pay Annually"}
              text={"Save 17% (2 months free) by paying annually."}
            />
          </Card>
        );
      }
    }
    return <Wrapper />;
  }
}

export default FrequencySwitch;
